// extracted by mini-css-extract-plugin
export default {"prizeLabel":"KTvk74rQwRk8Okd6hzVZ","fieldColumns":"Or0rKd1T7zT551XVJY61","inputBox":"u5Kf__CeFUBukShzDERJ"};